import React from "react";
import capabilities from "../data/capabilities.json";

// Map homepage capability cards to their detail routes by matching the number
// (falls back gracefully if the data drifts).
const slugByNumber = capabilities.reduce((acc, c) => {
  acc[c.number] = c.slug;
  return acc;
}, {});

export default function Capabilities({ data }) {
  if (!data) return null;
  return (
    <section id="capabilities" className="section">
      <div className="wrap">
        <div className="section-head">
          <span className="eyebrow">{data.eyebrow}</span>
          <h2 className="display-2">{data.title}</h2>
        </div>

        <div className="capability-list">
          {data.items.map((it, i) => {
            const slug = slugByNumber[it.number];
            const inner = (
              <>
                <div className="capability-number">§ {it.number}</div>
                <h3 className="capability-name">{it.name}</h3>
                <p className="capability-text">{it.text}</p>
                <div className="tag-row">
                  {it.tags.map((t, j) => (
                    <span key={j} className="tag">{t}</span>
                  ))}
                </div>
                {slug && (
                  <span className="capability-link" aria-hidden="true">
                    Explore {it.name.split(" ")[0].toLowerCase()} work →
                  </span>
                )}
              </>
            );
            return slug ? (
              <a
                key={i}
                className="capability capability--link"
                href={`/capabilities/${slug}`}
              >
                {inner}
              </a>
            ) : (
              <article key={i} className="capability">{inner}</article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
